import styles from './AddButton.module.css'

export default function AddButton() {
	return (
		<button type='submit' className={styles.button}>
			Add
		</button>
	)
}
